import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import {
	Text,
	Grid,
	Col,
	Button,
	Link,
	Badge,
} from "@website-builder/ui/shared/elements";

import { CTAWrapper, TextBlockWrapper } from "./styles";
import { handleCTAClick } from "@website-builder/utilities/utils/DesignUtils.js";
import { richTextResolver } from "@website-builder/utilities/utils/TransformerHelpers.js";

const TextBlock = ({
	labels,
	headlines,
	textItems,
	cta,
	colWidth,
	blockStyle,
	isDarkBg,
	context,
	pageSection,
}) => {
	const onCTAClick = (e, cta) => {
		e.preventDefault();
		console.log("cta == ", cta);
		const eventData = {
			page_section: pageSection,
			click_text: cta?.text,
			redirect_to: cta?.link?.link,
		};
		handleCTAClick(cta, eventData);
	};

	return (
		<TextBlockWrapper
			className="text-block-section"
			style={blockStyle}
			isDarkBg={isDarkBg}
		>
			<Grid>
				<Col start={colWidth[0]} span={colWidth[1]}>
					{labels.length > 0 ? (
						<div className="label-overflow">
							{labels.map((item, i) => {
								if (item.text) {
									return (
										<Badge
											key={`icon-badge-${i}`}
											textVariant={item?.type}
											bgColor={item?.backgroundColor?.color}
											textColor={item?.fontColor?.color}
										>
											{item.text}
										</Badge>
									);
								}
							})}
						</div>
					) : null}
					{headlines.map((headline, index) => {
						return (
							<Text
								variant={headline.variant}
								className="headlines"
								style={headline.textStyle}
								key={`text-block-item-${index}`}
							>
								{headline.content}
							</Text>
						);
					})}
					{textItems.map((text, index) => {
						return (
							<Text
								tag="div"
								variant={text.variant}
								className="text-items"
								style={text.textStyle}
								key={`text-block-item-${index}`}
								dangerouslySetInnerHTML={{
									__html: richTextResolver(text.content),
								}}
							/>
						);
					})}
					{cta.link ? (
						<CTAWrapper align={cta.align}>
							{cta.isButton ? (
								<Button
									buttonText={cta?.text}
									type={cta?.type}
									onClick={(e) => onCTAClick(e, cta)}
									darkBg={cta?.darkBg}
									disabled={cta?.disabled}
								/>
							) : (
								<Link
									arrowCta
									darkBg={isDarkBg}
									onClick={(e) => onCTAClick(e, cta)}
									linkText={cta?.text}
									href={cta?.link?.link}
									target={cta?.link?.target}
								/>
							)}
						</CTAWrapper>
					) : null}
				</Col>
			</Grid>
		</TextBlockWrapper>
	);
};

TextBlock.propTypes = {
	textItems: PropTypes.arrayOf(
		PropTypes.shape({
			variant: PropTypes.string,
			content: PropTypes.string,
			marginBottom: PropTypes.string,
			align: PropTypes.string,
		}),
	),
};

TextBlock.defaultProps = {
	textItems: [],
};

export default TextBlock;
